import template from './subcontracts.html';
import controller from './subcontracts.controller';

let subcontractsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default subcontractsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontracts/subcontracts.component.js